import { useState, useEffect, useRef } from 'react';

const MAX_HEIGHT = 600;
const HEIGHT_DELTA = 10;
const WIDTH = 1920;
const HEIGHT = 1080;

export const useResizer = () => {
  const sizeRef = useRef<HTMLDivElement | null>(null);
  const [size, setSize] = useState({
    width: 0,
    height: 0,
  });

  const handleSize = () => {
    const availableHeight = sizeRef?.current?.offsetHeight || 0;
    const availableWidth = sizeRef?.current?.offsetWidth || 0;

    let h = availableHeight;
    if (availableHeight <= HEIGHT_DELTA) {
      h = Math.min(availableWidth * (16 / 9), MAX_HEIGHT);
    }
    if (WIDTH > availableWidth || HEIGHT > h) {
      const ratio = Math.min(availableWidth / WIDTH, h / HEIGHT);
      setSize({ width: WIDTH * ratio, height: HEIGHT * ratio });
    } else {
      setSize({ width: WIDTH, height: HEIGHT });
    }
  };

  useEffect(() => {
    if (sizeRef?.current?.offsetWidth && size.width === 0) {
      handleSize();
    }
  }, [size.width]);

  useEffect(() => {
    window.addEventListener('resize', handleSize);
    return () => {
      window.removeEventListener('resize', handleSize);
    };
  }, []);

  return { sizeRef, size };
};
